var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "dayRangePicker" }, [
    _c("div", { staticClass: "monthsHeader" }, [
      _vm._v("\n    " + _vm._s(_vm.getMonthsTitle()) + "\n  "),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "dayBody" }, [
      _c(
        "header",
        { staticClass: "dayNames" },
        _vm._l(_vm.daysAvailable, function (day, index) {
          return _c("span", { key: index, staticClass: "dayLetter" }, [
            _vm._v("\n        " + _vm._s(day) + "\n      "),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "dayNumbers" },
        _vm._l(_vm.getRows(), function (row, index) {
          return _c(
            "div",
            { key: index, staticClass: "dayRow" },
            _vm._l(row, function (day, index) {
              return _c(
                "span",
                {
                  key: index,
                  class: _vm.getSelectableDateClass(day),
                  attrs: { tabindex: "0" },
                  on: {
                    click: function ($event) {
                      return _vm.handleClick(day)
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.handleClick(day)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "dayNumber" }, [
                    _vm._v(_vm._s(day.date.date())),
                  ]),
                ]
              )
            }),
            0
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }